import { BenefitTypes } from '@strata/constants';
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';

import { PharmacyIntegrationSendOnOption } from './constants';

dayjs.extend(isSameOrAfter);

export const useShowEReferralStatus = (referralDetails, supplierDetails) => {
    const eReferralBenefitAllowed =
        referralDetails?.benefit !== BenefitTypes.MEDICAL || supplierDetails?.allowMedical;

    let pastSendOnDate = false;
    if (
        supplierDetails?.sendOnOption === PharmacyIntegrationSendOnOption.SVC_START &&
        !!referralDetails?.referralStart
    ) {
        // To send an e-referral, we'd always expect a referral start date.
        pastSendOnDate = dayjs().isSameOrAfter(dayjs(referralDetails.referralStart));
    } else if (supplierDetails?.sendOnOption === PharmacyIntegrationSendOnOption.OUTREACH) {
        // The outreach date can be null even if the send on option is outreach.
        // If null, we should ignore this check, and let pastSendOnDate be true.
        pastSendOnDate =
            !referralDetails?.outreachDate ||
            dayjs().isSameOrAfter(dayjs(referralDetails.outreachDate));
    } else {
        pastSendOnDate = false;
    }

    return eReferralBenefitAllowed && supplierDetails?.integrationAvailable && pastSendOnDate;
};
